import React from 'react';
import { observer } from 'mobx-react';
import { Components } from '@singularsystems/neo-core';
import { Neo } from '@singularsystems/neo-react';
import { IPreAuthorisable } from '../Models/IPreAuthorisable';
import { IAuthorisable } from '../Models/IAuthorisable';
import AuthorisationVM from '../Services/AuthorisationVM';

interface IAuthoriseButtonProps extends Components.IButtonOptions {
    
    viewModel: AuthorisationVM;
    currentRecord: IPreAuthorisable | IAuthorisable;
    preAuthoriseRoleName?: string;
    authoriseRoleName: string;
    onDelete: () => void;
}

@observer
export default class AuthoriseButton extends React.Component<IAuthoriseButtonProps> {

    constructor(props: IAuthoriseButtonProps) {
        super(props);
    }
    

    public render() {
        function isIAuthorisable(record: IPreAuthorisable | IAuthorisable): record is IAuthorisable {
            return (record as IAuthorisable).authorisation !== undefined;
        }

        const { viewModel, currentRecord, preAuthoriseRoleName , authoriseRoleName, onDelete, ...buttonProps } = this.props;
        const authorisation = isIAuthorisable(currentRecord) ? currentRecord.authorisation: null;
        const typeName = AuthorisationVM.getTypeName(currentRecord.constructor);
        
        if (currentRecord.isNew) {
            return null;
        }

        return (
            <Neo.Button 
                {...buttonProps}
                disabled={currentRecord.isDirty}
                variant={authorisation?.isAuthorised ? "secondary" : "warning"}
                icon={authorisation?.isAuthorised ? "user-check" : "stamp"}
                tooltip={typeName + (authorisation?.isAuthorised ? " is currently authorised" : " is not Authorised")}
                menuItems={[{text: "View Changes", onClick: () => viewModel.viewAuditHistory(currentRecord, preAuthoriseRoleName ,authoriseRoleName, onDelete)}]}>
            </Neo.Button>
        );
    }
}